import { format } from 'date-fns'
import { id } from 'date-fns/locale'

export default {
  date: (dt: string | number | Date, fmt: string = 'PP') => {
    return format(dt, fmt, { locale: id })
  },
}
